import { useEffect, useRef, useState } from "react";
import { ScrollTheMouseWheelIcon } from "frontend/icons/scroll-the-mouse-wheel";
import SuccessAnimation from "frontend/canvas-onboarding/cim-onboarding/phases/device-selection/success-animation/success-animation";
import styles from "./navigation-step.module.css";
import { useAtomValue } from "jotai";
import { posScaleAtom } from "state-atoms";
import tracking from "frontend/tracking";

interface MouseZoomStepProps {
  name: string;
  completeStep: () => void;
}

export default function MouseZoomStep({ name, completeStep }: MouseZoomStepProps) {
  const posScale = useAtomValue(posScaleAtom);
  const [showSuccess, setShowSuccess] = useState(false);
  const currentScale = useRef<number>(posScale.scale);
  const hasCompletedRef = useRef(false);

  useEffect(() => {
    if (!hasCompletedRef.current && posScale.scale !== currentScale.current) {
      hasCompletedRef.current = true;
      currentScale.current = posScale.scale;

      setShowSuccess(true);
      tracking.trackAnalyticsEvent(`${name}_success`);
    }
  }, [posScale, name]);

  return (
    <SuccessAnimation showSuccess={showSuccess} successImage="hopa" onComplete={completeStep}>
      <div className={styles.container}>
        <div className={styles.mouseIconWrapper}>
          <ScrollTheMouseWheelIcon />
        </div>
      </div>
    </SuccessAnimation>
  );
}
